import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface LanguageDropdownProps {
  currentLanguage: string;
  changeLanguage: (language: string) => Promise<void> | void;
}

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({ currentLanguage, changeLanguage }) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>('中文');
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isChanging, setIsChanging] = useState<boolean>(false);
  const open = Boolean(anchorEl);

  useEffect(() => {
    setSelectedLanguage(currentLanguage === 'zh' ? '中文' : 'English');
  }, [currentLanguage]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleLanguageChange = async (language: string, label: string): Promise<void> => {
    try {
      setIsChanging(true);
      await changeLanguage(language);
      setSelectedLanguage(label);
    } catch (error) {
      console.error('Error changing language:', error);
      // Keep the current language if there's an error
      setSelectedLanguage(currentLanguage === 'zh' ? '中文' : 'English');
    } finally {
      setIsChanging(false);
      handleClose();
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{ mr: 3, backgroundColor: '#cba694' }}
        disabled={isChanging}
      >
        {isChanging ? 'Changing...' : selectedLanguage}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => handleLanguageChange('en', 'English')}
          disabled={isChanging}
        >
          English
        </MenuItem>
        <MenuItem
          onClick={() => handleLanguageChange('zh', '中文')}
          disabled={isChanging}
        >
          中文
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageDropdown;
